import React from 'react';
import { Route, HashRouter, Routes, useParams, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { RoutePath } from './RoutePath';
import ViewInvoice from './pages/viewInvoice/ViewInvoice'
import PayInvoice from './pages/payInvoice/PayInvoice'
import ViewInvoiceList from './pages/viewInvoiceList/ViewInvoiceList'
import { createAnalyticsService } from './services/CreateAnalyticsService';
import { createInvoiceService } from './services/CreateInvoiceService';
import Activity from './pages/activity/Activity';
import { createPaymentService } from './services/CreatePaymentService';
import { IPaymentService } from './services/IPaymentService';
import { IAnalyticsService } from './services/IAnalyticsService';
import { PayInvoiceList } from './pages/payInvoice/PayInvoiceList';

const WrapperService = (props) => {

    const navigate = useNavigate();
    function navigateToPage(link) {
        navigate(link);
    }

    const params = useParams();
    const { children } = props;
    return <div> {React.cloneElement(children, { params, navigateToPage, useLocation: useLocation() })}</div>
}

class App extends React.Component {
    private invoiceService: any;

    constructor(
        private paymentService: IPaymentService,
        private analyticsService: IAnalyticsService
    ) {
        super({});
        this.onSetService();
    }

    componentDidMount() {
        document.title = "MYOB - Invoice portal"
    }

    render() {
        return (
            <HashRouter>
                <Routes>
                    <Route path={RoutePath.VIEW_INVOICE}
                           element={
                               <WrapperService>
                                   <ViewInvoice notifyEvent={this.analyticsService.notifyEvent}
                                                getInvoice={this.invoiceService.getInvoice}
                                                retrieveSuppliersFeed={this.invoiceService.retrieveSuppliersFeed}
                                                createSupplierFeed={this.invoiceService.createSupplierFeed}
                                                login={this.invoiceService.login}
                                                submitToInTray={this.invoiceService.submitToInTray}
                                                getCompanyList={this.invoiceService.getCompanyList}
                                                closeSelectCompany={this.invoiceService.closeSelectCompany}
                                                getInvoicePdf={this.invoiceService.getInvoicePdf}
                                                removeSupplierFeed={this.invoiceService.removeSupplierFeed}/>
                               </WrapperService>
                           }/>
                    <Route path={RoutePath.PAY_INVOICE}
                           element={
                               <WrapperService>
                                   <PayInvoice notifyEvent={this.analyticsService.notifyEvent}
                                               getInvoice={this.invoiceService.getInvoice}
                                               initPaymentSelector={this.paymentService?.initPaymentSelector}/>
                               </WrapperService>
                           }
                    />
                    <Route path={RoutePath.INVOICE_LIST}
                           element={
                               <WrapperService>
                                   <ViewInvoiceList postInvoiceList={this.invoiceService.postInvoiceList}
                                                    getInvoiceList={this.invoiceService.getInvoiceList}
                                                    notifyEvent={this.analyticsService.notifyEvent}
                                   />
                               </WrapperService>}/>
                    <Route path={RoutePath.PAY_INVOICE_LIST}
                           element={
                               <WrapperService>
                                   <PayInvoiceList
                                       notifyEvent={this.analyticsService.notifyEvent}
                                       getBulkPaymentRecord={this.paymentService.getBulkPaymentRecord}
                                       initPaymentSelector={this.paymentService.initPaymentSelector}
                                   />
                               </WrapperService>}/>
                    <Route path={RoutePath.ACTIVITY}
                           element={
                               <WrapperService><Activity getInvoice={this.invoiceService.getInvoice}/></WrapperService>
                           }/>
                </Routes>
            </HashRouter>
        );
    }

    private onSetService = () => {
        const publicUrl = '';
        this.invoiceService = createInvoiceService(
            publicUrl
        );
        this.analyticsService = createAnalyticsService(
            publicUrl
        );
        this.paymentService = createPaymentService(publicUrl);
    }

}

export default App;
